import { Controller } from "@hotwired/stimulus"

const AA_LANE_SELECTOR = 'div[data-lang|="text"]'
const MIN_SCALE = 0.5
const SCALE_PRECISION = 1000

// Connects to data-controller="aa-fit"
export default class extends Controller {
  #observer
  #pending

  connect() {
    this.#fitAll()
    // webfont 適用前は fallback フォントの幅で測ってしまい縮小率がずれる
    document.fonts.ready.then(this.#fitAll)
    // 幅の変化だけでなく、プレビュー差し替えなど後から現れた AA も拾うため window resize ではなく監視する
    this.#observer = new ResizeObserver(this.#scheduleFitAll)
    this.#observer.observe(this.element)
  }

  disconnect() {
    this.#observer.disconnect()
    cancelAnimationFrame(this.#pending)
  }

  #fitAll = () => {
    this.element.querySelectorAll(AA_LANE_SELECTOR).forEach(frame => this.#fit(frame))
  }

  #scheduleFitAll = () => {
    cancelAnimationFrame(this.#pending)
    this.#pending = requestAnimationFrame(this.#fitAll)
  }

  #fit(frame) {
    const code = frame.querySelector("pre > code")
    if (!code) return

    const pre = code.parentElement
    frame.style.removeProperty("--aa-scale")
    // 折り返しを戻さないと、一度折り返した AA は素の幅を測れず二度と縮小に戻れない
    code.style.removeProperty("white-space")
    // CSS が倍率を与えているブロック (```text-80) は著者の指定なので自動縮小しない
    if (getComputedStyle(frame).getPropertyValue("--aa-scale")) return

    const style = getComputedStyle(pre)
    const padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)
    const available = pre.clientWidth - padding
    const content = pre.scrollWidth - padding
    if (available <= 0 || content <= available) return

    // 切り上げると再びはみ出すので floor
    const scale = Math.floor((available / content) * SCALE_PRECISION) / SCALE_PRECISION
    // 読めない大きさにしてまで 1 行に収めない。下限を割る AA は縮小前の折り返し表示に戻す
    if (scale < MIN_SCALE) code.style.whiteSpace = "pre-wrap"
    else frame.style.setProperty("--aa-scale", scale)
  }
}
